<template>
  <a href="https://complexearth.uk">
    <img
      class="complex-earth-logo"
      src="../assets/CE_Long-Logo_White_hi-res.png"
      alt="Complex Earth"
    />
  </a>
</template>

<script>
export default {
  name: "ComplexEarthLogo",
};
</script>

<style scoped>
.complex-earth-logo {
  max-height: 2em;
  margin-bottom: -2px;
}
</style>
